import RestService from './RestService';

export default class Tags extends RestService {
    constructor() {
        super('/tags');
    }
}
